export default __webpack_public_path__ + "static/pragicts-digital-outreach-banner-revolution-c596aa7664592fb969c0903eb28e431e.jpg";